import createDecorator from 'final-form-calculate';
import uniqBy from 'lodash/uniqBy';

export function getUsersFromWorkspaces(workspaces) {
  return uniqBy(
    workspaces.reduce((array, memo) => {
      if (Array.isArray(array)) return [...array, ...memo.users];
      return [...array.users, ...memo.users];
    }),
    'id'
  );
}

export const decorator = createDecorator(
  {
    field: 'searchStr',
    updates: {
      page: () => 1,
    },
  },
  {
    field: 'assignedBy',
    updates: {
      page: () => 1,
    },
  },
  {
    field: 'assignedTo',
    updates: {
      page: () => 1,
    },
  },
  {
    field: 'endDate',
    updates: {
      page: () => 1,
    },
  },
  {
    field: 'startDate',
    updates: {
      page: () => 1,
    },
  },
  {
    field: 'workspacesIds',
    updates: {
      page: () => 1,
    },
  },
  {
    field: 'completed',
    updates: {
      page: () => 1,
    },
  }
);
